export default __webpack_public_path__ + "static/logo-b60375ec4271311e227baa58423841cd.png";